import logo from '../../../../assets/images/logo.png';
import { useIsMobile } from '../../../../hooks/hooks';

export const Menu = ({ onToggleMenu }) => {
  const isMobile = useIsMobile();
  return (
    <>
      {!isMobile && (
        <img src={logo} style={{ width: '90px' }} alt="Хореографічна студія «Мрія»" />
      )}
      <ul className="nav-bar">
        <li>
          <a href="/#home" onClick={onToggleMenu}>
            Головна
          </a>
        </li>
        <li>
          <a href="/#about" onClick={onToggleMenu}>
            Про студію
          </a>
        </li>
        <li>
          <a href="/#teachers" onClick={onToggleMenu}>
            Викладачі
          </a>
        </li>
        <li>
          <a href="/#gallery" onClick={onToggleMenu}>
            Галерея
          </a>
        </li>
        <li>
          <a href="/#contacts" onClick={onToggleMenu}>
            Контакти
          </a>
        </li>
        <li>
          <a href="/documents" onClick={onToggleMenu}>
            Документи
          </a>
        </li>
      </ul>
    </>
  );
};
